<template>
    <div class="menu menu-sub menu-sub-dropdown w-250px w-md-300px" data-kt-menu="true">
        <div class="px-7 py-5">
            <div class="fs-5 text-dark fw-bolder">{{ $t('filters.title') }}</div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5 overflow-auto max-h-300px">
            <div class="mb-10" v-if="!userID">
                <label class="form-label fw-bold">{{ $t('filters.module.vehicleWorkOrder.id') }}:</label>
                <div>
                    <el-input v-model="filterData.id" oninput="value=value.replace(/[^0-9.]/g,'')"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.module.vehicleWorkOrder.customerCarPlate') }}:</label>
                <div>
                    <el-input v-model="filterData.customer_vehicle_plate" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.module.vehicleWorkOrder.customerMobilePhone') }}:</label>
                <div>
                    <el-input v-model="filterData.customer_mobile_phone" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.module.vehicleWorkOrder.status') }}:</label>
                <div>
                    <el-select v-model="filterData.status_id" class="w-100" :placeholder="$t('common.chooseSelect')" filterable>
                        <el-option v-for="(item, itemIndex) in statusList" :key="itemIndex" :value="item" :label="$t('pages.module.VEHICLE_WORK_ORDER.cols.status.' + item)"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.module.vehicleWorkOrder.companyCustomerId') }}:</label>
                <div>
                    <el-input v-model="filterData.company_customer_id" oninput="value=value.replace(/[^0-9.]/g,'')"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.module.vehicleWorkOrder.customerVehicleId') }}:</label>
                <div>
                    <el-input v-model="filterData.customer_vehicle_id" oninput="value=value.replace(/[^0-9.]/g,'')"/>
                </div>
            </div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5">
            <div class="d-flex justify-content-end">
                <button type="reset" v-on:click="onReset" class="btn btn-sm btn-white btn-active-light-primary me-2" data-kt-menu-dismiss="true">{{ $t('btn.reset') }}</button>
                <button type="submit" v-on:click="onFilter" class="btn btn-sm btn-primary" data-kt-menu-dismiss="true">{{ $t('btn.apply') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data() {
        return {
            filterData: {},
            statusList: [1, 2, 3, 4, 5, 6],
            cities: []
        }
    },
    computed: {
        userID() {
            return this.$route.query.userID;
        },
    },
    mounted() {
        if (this.userID) {
            this.filterData.id = this.userID;
        }
    },
    methods: {
        onReset() {
            this.filterData = {};
            this.onFilter();
        },
        onFilter() {
            this.$emit('onFilter', this.filterData);
        },
    },
    watch: {
        'filterData.user_id'(newVal, oldVal) {
            if (newVal !== oldVal) {
                if (this.filterData.user_id) {
                    this.filterData.customer_car_id = undefined;
                    this.$store.dispatch('customer/vehicle/get', {
                        filterData: {
                            user_id: this.filterData.user_id
                        },
                        page: {
                            pageSize: 9999
                        }
                    });
                } else {
                    this.$store.dispatch('customer/vehicle/get', {
                        page: {
                            pageSize: 9999
                        }
                    });
                }
            }
        }
    }
}
</script>

<style>

</style>